<div class="modal-display">
<h3>Oops! Something went wrong.</h3>
<div>
<p>
  Your bank details have not been saved.
  <br>There may be a problem with your internet connection.
  <br>Check your internet access and try again.
  <br>Still not working? You can come back to it later and re-enter your bank
  <br>details, simply log back in using your email and password or <a href="https://www.kernelwealth.co.nz/contact" target="_blank">contact us</a>.
</p>
</div>
    <div class="modal-buttons modal-buttons--close">
        <button class="a-rounded-button--primary" (click)="closeDialog()">OK</button>
    </div>
</div>
